import React, { Component } from "react";
import { Consume } from "../../Context/Consumer";
import {
  TeamDataContext,
  CompositionContext,
  FixturesContext,
  BoosterCardContext,
  GamedaysContext,
  TransContext,
  PlayerListContext,
} from "../../Context";
import config from "../../common/config";
import {
  calcTime,
  getBoostersObject,
  getPlayingEleven,
  getTrans,
  getTransferArray,
  makeClasses,
  makeManageTeamSkeleton,
  updateBusters,
} from "../../common";
import PlayerImage from "../playerImage";
import { Scrollbars } from "react-custom-scrollbars";

class BoosterPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      objSelectedBooster: { isShow: false },
      playerCaptain: {},
      helpIconOpen: -1,
      pLtooltipIsHovered: false,
      isFreeze: false,
    };
  }
  setIsShownPLTooltip = (value) => {
    this.setState((prevState) => ({
      pLtooltipIsHovered: !prevState.pLtooltipIsHovered,
      helpIconOpen: value,
    }));
  };

  closeIshownPLTooltip = () => {
    this.setState({
      pLtooltipIsHovered: false,
    });
  };
  selectBooster = (booster) => {
    let self = this;
    self.setState({
      objSelectedBooster: {
        isShow: true,
        booster: booster,
      },
    });
  };
  submitBooster = (booster) => {
    let self = this;
    let { BoosterId } = booster;
    let { props, state } = self;
    let {
      BoosterCardData,
      Gamedays,
      TeamData,
      CompositionData,
      showHideToast,
      showHideBoosterPopup,
      FixturesData,
      goToTransfers,
    } = props;
    let trans = this.props.TransData.data;
    let apiParams = {};

    self.setState({
      isFreeze: true,
    });
    if (config.enumBoosterTypes.one.indexOf(BoosterId + "") > -1) {
      apiParams = {
        platform: config.platformId,
        gamedayId: FixturesData.currMatchDay.GamedayId,
        phaseId: FixturesData.currMatchDay.PhaseId,
        boosterId: BoosterId,
        captainId: TeamData.data.captainID,
        gdCompId:
          CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID].CompId,
        mdCompId: TeamData.data.CompId,
      };
    } else if (config.enumBoosterTypes.two.indexOf(BoosterId + "") > -1) {
      let selectedTeamT = { ...Gamedays.selectedTeam };
      selectedTeamT.Boosters.forEach((obj, ind) => {
        if (obj.Id === BoosterId) {
          selectedTeamT.Boosters[ind].IsTaken = 1;
          selectedTeamT.Boosters[ind].GdId =
            FixturesData.currMatchDay.GamedayId;
        }
      });
      Gamedays.setSelectedTeam(selectedTeamT);
      BoosterCardData.setTempLimitlessBooster(true);
      showHideBoosterPopup(false);
      goToTransfers && goToTransfers();
    } else if (config.enumBoosterTypes.three.indexOf(BoosterId + "") > -1) {
      apiParams = {
        platform: config.platformId,
        gamedayId: FixturesData.currMatchDay.GamedayId,
        phaseId: FixturesData.currMatchDay.PhaseId,
        boosterId: BoosterId,
        captainId: TeamData.data.captainID,
        bsCaptainId: state.playerCaptain.id,
        gdCompId:
          CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID].CompId,
        mdCompId: TeamData.data.CompId,
      };
    }
    config.enumBoosterTypes.two.indexOf(BoosterId + "") == -1 &&
      BoosterCardData[
        config.enumBoosterTypes.two.indexOf(BoosterId + "") > -1
          ? "submitLimitlessBooster"
          : "submitBooster"
      ](
        apiParams,
        (resp) => {
          let msg = getTrans(
            trans,
            "Booster_Applied_Success",
            "The Booster is applied Successfully"
          );
          showHideBoosterPopup(false);
          showHideToast(
            true,
            msg,
            false,
            false,
            FixturesData.screenMode === config.screenMode.transfer
          );
          updateBusters("/team");
          let params = {
            optType: config.optType,
            gamedayId: FixturesData.currMatchDay.GamedayId,
            phaseId: FixturesData.currMatchDay.PhaseId,
            language: config.language,
          };
          Gamedays.getSelectedTeam(
            params,
            (response) => {
              let teamDataSkeleton = makeManageTeamSkeleton(
                response?.Data?.Value,
                self.props.PlayerListData.rawPlayerList,
                self.props.CompositionData.data
              );
              self.props.TeamData.setTeamData(teamDataSkeleton.teamData);
              FixturesData.setGameMode(config.modes.transfer);
              self.setState({
                isFreeze: false,
              });
            },
            () => {}
          );
        },
        (err) => {
          let retVal = err.RetVal;
          if (retVal === 502) {
            let msg = getTrans(
              trans,
              "Already_Applied_Booster",
              "You have already applied one booster for this gameday"
            );
            showHideBoosterPopup(false);
            showHideToast(true, msg, false);
          }
          self.setState({
            isFreeze: false,
          });
        }
      );
  };
  onSelectCaptain = (player) => {
    console.log(player);
    let self = this;
    self.setState({ playerCaptain: player });
  };
  render() {
    let self = this;
    let { state, props, selectBooster, submitBooster, onSelectCaptain } = self;
    let { objSelectedBooster, playerCaptain, isFreeze } = state;
    let {
      TeamData,
      CompositionData,
      showHideBoosterPopup,
      Gamedays,
      TransData,
    } = props;
    const transData = TransData.data;
    let boosters = getBoostersObject(
      CompositionData.boostersList,
      Gamedays.selectedTeam.Boosters
    );
    let manageTeamBoosters = [];
    let makeTransfersBoosters = [];
    let playingElevenWithoutCap = [];
    boosters.forEach((obj) => {
      if (config.MakeTransfersBoosterIds.indexOf(obj.BoosterId + "") > -1) {
        makeTransfersBoosters.push(obj);
      } else {
        manageTeamBoosters.push(obj);
      }
    });
    if (
      config.enumBoosterTypes.three.indexOf(
        objSelectedBooster.booster?.BoosterId + ""
      ) > -1
    ) {
      playingElevenWithoutCap = getPlayingEleven(TeamData.data, false);
    }
    let popupHead = (
      <div className="si-popup__head">
        <div
          className="si-popup__close"
          onClick={() => showHideBoosterPopup(false)}
        >
          <div className="si-btn__adRe"></div>
        </div>
        <div className="si-popup__title">
          <span>
            {getTrans(
              transData,
              "Booster_PopUp_Title",
              "SELECT BOOSTER TO PLAY"
            )}
          </span>
        </div>
      </div>
    );
    let popupRules = null;
    let rulesList = config.WebConfig.BoosterRules[
      objSelectedBooster.booster?.BoosterId
    ]?.rule.map((rule, index) => {
      return <li key={index}>{getTrans(transData, rule)}</li>;
    });
    popupRules = (
      <div className="si-booster__details-list">
        <ul>
          {rulesList}
          <li className={"si-text--black"}>
            <b>
              {getTrans(
                transData,
                "common_buster_rule",
                "*For all conditions on the usage of boosters please visit the rules page."
              )}
            </b>
          </li>
        </ul>
      </div>
    );

    let popupBody = null;
    popupBody = (
      <>
        {self.props.FixturesData.screenMode ===
          config.screenMode["view-manage-team"] && (
          <div className="si-booster__container">
            <div className="si-league__header">
              <div className="si-league__title">
                {getTrans(
                  transData,
                  "Manage_Team_Boosters",
                  "Manage team boosters"
                )}
              </div>
              <div
                onMouseEnter={() =>
                  !config.isMobile ? this.setIsShownPLTooltip(0) : null
                }
                onMouseLeave={() =>
                  !config.isMobile ? this.setIsShownPLTooltip(0) : null
                }
                onClick={() =>
                  config.isMobile ? this.setIsShownPLTooltip(0) : null
                }
                className={`si-help__wrap ${
                  this.state.pLtooltipIsHovered && this.state.helpIconOpen == 0
                    ? "si-active"
                    : ""
                }`}
              >
                <div className="si-help__icon">
                  <i className="uae-info"></i>
                </div>
                <div className="si-help__tooltip">
                  {getTrans(
                    transData,
                    "Manage_Team_Boosters_Tooltip",
                    "These boosters can be changed anytime before the game week gets locked."
                  )}
                </div>
              </div>
            </div>
            <ul>
              {manageTeamBoosters.map((elem, ind) => {
                let boosterClasses = makeClasses({
                  "si-booster__box": true,
                  "si-used": elem.IsTaken,
                  "si-disabled": !elem.IsActive,
                });
                return (
                  <li key={ind}>
                    <div
                      className={boosterClasses}
                      onClick={() => selectBooster(elem)}
                    >
                      <div className="si-booster__box-thumb">
                        <img
                          src={`${config.IMG_BASE}boosters/${elem.BoosterId}.svg?v=${config.WebConfig.imgVersion}`}
                          alt={getTrans(
                            transData,
                            config.WebConfig.BoosterRules[elem.BoosterId].name
                          )}
                          title={getTrans(
                            transData,
                            config.WebConfig.BoosterRules[elem.BoosterId].name
                          )}
                        />
                      </div>
                      <div className="si-booster__box-content">
                        <div className="si-booster__box-title">
                          <span>
                            {getTrans(
                              transData,
                              config.WebConfig.BoosterRules[elem.BoosterId].name
                            )}
                          </span>
                        </div>
                        {elem.IsTaken && (
                          <div className="si-booster__box-lable">
                            <span>
                              {getTrans(
                                transData,
                                "Played_on_txt",
                                "Played on"
                              )}{" "}
                              {elem.GdId}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="si-booster__container">
          <div className="si-league__header">
            <div className="si-league__title">
              {getTrans(transData, "Transfer_Boosters", "Transfer boosters")}
            </div>
            <div
              onMouseEnter={() =>
                !config.isMobile ? this.setIsShownPLTooltip(1) : null
              }
              onMouseLeave={() =>
                !config.isMobile ? this.setIsShownPLTooltip(1) : null
              }
              onClick={() =>
                config.isMobile ? this.setIsShownPLTooltip(1) : null
              }
              className={`si-help__wrap ${
                this.state.pLtooltipIsHovered && this.state.helpIconOpen == 1
                  ? "si-active"
                  : ""
              }`}
            >
              <div className="si-help__icon">
                <i className="uae-info"></i>
              </div>
              <div className="si-help__tooltip">
                {getTrans(
                  transData,
                  "Transfer_Boosters_Tooltip",
                  "These boosters cannot be changed once transfers are made applying the booster."
                )}
              </div>
            </div>
          </div>
          <ul>
            {makeTransfersBoosters.map((elem, ind) => {
              let boosterClasses = makeClasses({
                "si-booster__box": true,
                "si-used": elem.IsTaken,
                "si-disabled": !elem.IsActive,
              });
              return (
                <li key={ind}>
                  <div
                    className={boosterClasses}
                    onClick={() => selectBooster(elem)}
                  >
                    <div className="si-booster__box-thumb">
                      <img
                        src={`${config.IMG_BASE}boosters/${elem.BoosterId}.svg?v=${config.WebConfig.imgVersion}`}
                        alt={getTrans(
                          transData,
                          config.WebConfig.BoosterRules[elem.BoosterId].name
                        )}
                        title={getTrans(
                          transData,
                          config.WebConfig.BoosterRules[elem.BoosterId].name
                        )}
                      />
                    </div>
                    <div className="si-booster__box-content">
                      <div className="si-booster__box-title">
                        <span>
                          {getTrans(
                            transData,
                            config.WebConfig.BoosterRules[elem.BoosterId].name
                          )}
                        </span>
                      </div>
                      {elem.IsTaken && (
                        <div className="si-booster__box-lable">
                          <span>
                            {getTrans(transData, "Played_on_txt", "Played on")}{" "}
                            {elem.GdId}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </>
    );
    if (objSelectedBooster.isShow) {
      popupBody = (
        <>
          <div
            className="si-popup__close"
            onClick={() => showHideBoosterPopup(false)}
          >
            <div className="si-btn__adRe"></div>
          </div>
          <div className="si-booster__details">
            <div className="si-booster__box">
              <div className="si-booster__box-thumb">
                <img
                  src={`${config.IMG_BASE}boosters/${objSelectedBooster.booster.BoosterId}.svg?v=${config.WebConfig.imgVersion}`}
                  alt={getTrans(
                    transData,
                    config.WebConfig.BoosterRules[
                      objSelectedBooster.booster.BoosterId
                    ].name
                  )}
                  title={getTrans(
                    transData,
                    config.WebConfig.BoosterRules[
                      objSelectedBooster.booster.BoosterId
                    ].name
                  )}
                />
              </div>
              <div className="si-booster__box-content">
                <div className="si-booster__box-title">
                  <span>
                    {getTrans(transData, "playing", "Playing:")}{" "}
                    {getTrans(
                      transData,
                      config.WebConfig.BoosterRules[
                        objSelectedBooster.booster.BoosterId
                      ].name
                    )}
                  </span>
                </div>
              </div>
            </div>
            {config.enumBoosterTypes.three.indexOf(
              objSelectedBooster.booster?.BoosterId + ""
            ) > -1 ? (
              <Scrollbars className="si-scroll_js si-booster__details-scroll">
                {popupRules}
                <div className="si-booster__details-plyr">
                  <div className="si-booster__details-info">
                    <span>
                      {getTrans(
                        transData,
                        "Select_Second_Captain_Txt",
                        "Select your second captain"
                      )}
                    </span>
                  </div>
                  <div className="si-plyrSel__wrap">
                    <div className="si-plyrSel__list">
                      <div className="si-plyrSel__tbl si-plyrSel__tbl--head">
                        <div className="si-tbl">
                          <div className="si-tbl__head">
                            <div className="si-tbl__row">
                              <div className="si-tbl__cell si-tbl__cell--name">
                                <span>
                                  {getTrans(transData, "players", "Players")}
                                </span>
                              </div>
                              <div className="si-tbl__cell si-tbl__cell--pts">
                                <span>
                                  {getTrans(transData, "AED", "AED")}{" "}
                                  {getTrans(transData, "brackMilli", "(M)")}
                                </span>
                              </div>
                              <div className="si-tbl__cell si-tbl__cell--amt">
                                <span>
                                  {getTrans(transData, "pts_cap_txt", "PTS")}
                                </span>
                              </div>
                              <div className="si-tbl__cell si-tbl__cell--cta"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul>
                        {playingElevenWithoutCap?.map((elem, ind) => {
                          return (
                            <li
                              className={
                                elem.id === playerCaptain.id ? "si-remove" : ""
                              }
                              key={ind}
                              onClick={() => onSelectCaptain(elem)}
                            >
                              <div className="si-tbl">
                                <div className="si-tbl__body">
                                  <div className="si-tbl__row">
                                    <div className="si-tbl__cell si-tbl__cell--name">
                                      <div className="si-plyrSel__fBox">
                                        <div className="si-plyrSel__fItem--lft">
                                          <PlayerImage
                                            playerId={elem.details.Id}
                                            teamId={elem.details.TeamId}
                                          />
                                        </div>
                                        <div className="si-plyrSel__fItem--rgt">
                                          <div className="si-plyrSel__name">
                                            <span>
                                              {elem.details.DisplayName}{" "}
                                            </span>
                                          </div>
                                          <div className="si-plyrSel__stats">
                                            <span>
                                              vs{" "}
                                              {
                                                elem.details
                                                  .UpComingMatchesList[0]
                                                  .VsTeamShortCode
                                              }
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="si-tbl__cell si-tbl__cell--pts">
                                      <span>
                                        {Math.round(elem.value * 100) / 100}
                                      </span>
                                    </div>
                                    <div className="si-tbl__cell si-tbl__cell--cta">
                                      <div
                                        className={
                                          "si-booster__details-select " +
                                          (elem.id === playerCaptain.id
                                            ? "si-active"
                                            : "")
                                        }
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </Scrollbars>
            ) : (
              popupRules
            )}
          </div>
        </>
      );
    }
    let popupFoot = (
      <div className="si-popup__foot">
        <div
          className="si-btn si-btn__primary si-btn__primary--outline"
          onClick={() => {
            showHideBoosterPopup(false);
          }}
        >
          <span>{getTrans(transData, "cancel", "Cancel")}</span>
        </div>
        <div
          className={
            "si-btn si-btn__primary " +
            (objSelectedBooster.booster?.IsActive &&
            (config.enumBoosterTypes.three.indexOf(
              objSelectedBooster.booster?.BoosterId + ""
            ) > -1
              ? playerCaptain?.id
              : true)
              ? ""
              : "si-disabled")
          }
          onClick={() => {
            !isFreeze &&
              objSelectedBooster.booster?.IsActive &&
              submitBooster(objSelectedBooster.booster);
          }}
        >
          <span>{getTrans(transData, "play_now", "Play Now")}</span>
        </div>
      </div>
    );

    return (
      <div
        className={
          "si-popup__wrap si-booster__popup si-fade in " +
          (config.enumBoosterTypes.three.indexOf(
            objSelectedBooster.booster?.BoosterId + ""
          ) > -1
            ? "si-booster__2c"
            : "")
        }
      >
        <div
          className="si-popup__container"
          style={{ maxHeight: "calc(100vh - 60px)" }}
        >
          {objSelectedBooster.isShow ? null : popupHead}
          {objSelectedBooster.isShow ? (
            <div className="si-popup__body">{popupBody}</div>
          ) : (
            <div
              className="si-popup__body"
              style={{ height: "calc(100vh - 60px)", padding: 0 }}
            >
              <Scrollbars className="si-scroll_js">
                <div style={{ padding: "10px" }}>{popupBody}</div>
              </Scrollbars>
            </div>
          )}
          {objSelectedBooster.isShow ? popupFoot : null}
        </div>
      </div>
    );
  }
}

export default Consume(BoosterPopup, [
  TeamDataContext,
  CompositionContext,
  BoosterCardContext,
  GamedaysContext,
  TransContext,
  FixturesContext,
  PlayerListContext,
]);
